
const setStepPersonalCredit = step => {
  switch (step) {
    case "PERSONAL-INFORMATION":
      return "ADDRESS"

    case "ADDRESS":
      return "LABOR-DATA"

    case "LABOR-DATA":
      return "CDC"
    case "CDC":
      return "PERSONAL-REFERENCES"

    case "PERSONAL-REFERENCES":
      return "QUESTION-PEPS"

    case "QUESTION-PEPS":
      return "FINISHED"
  
    default:
      return "";
  }
}

export default setStepPersonalCredit
